import React from "react";
import StarLawyersImage from "../assets/star_lawyers-header.png";
import StarLawyer from "../assets/star-lawyer.png";
import "../styles/StarLawyersHeader.css";
import "../styles/StarLawyersMain.css";
import StarLawyerCard from "../components/StarLawyerCard";

const StarLawyersPage = () => {
    const starLawyersData = [
        {
            src: StarLawyer,
            name: "John Doe",
            specialisation: "Real Estate Law",
            description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
        },
        {
            src: StarLawyer,
            name: "John Doe",
            specialisation: "Real Estate Law",
            description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
        },
        {
            src: StarLawyer,
            name: "John Doe",
            specialisation: "Real Estate Law",
            description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
        },
        {
            src: StarLawyer,
            name: "John Doe",
            specialisation: "Real Estate Law",
            description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.`,
        },
    ];

    return (
        <>
            <header>
                <div className="star_lawyers-header-wrapper">
                    <img src={StarLawyersImage} alt="" className="star_lawyers-header-image" />
                    <div className="star_lawyers-image-gradient" />
                    <div className="row">
                        <div className="star_lawyers-header-content">
                            <h1 className="star_lawyers-header-title">Our Star Lawyers</h1>
                            <p className="star_lawyers-header-para">
                                Lorem Ipsum is simply dummy text of the printing and typesetting
                                industry
                            </p>
                        </div>
                    </div>
                </div>
            </header>
            <main>
                <div className="row">
                    <div className="star_lawyers-cards">
                        {starLawyersData.map((starLawyer, index) => {
                            return (
                                <StarLawyerCard starLawyer={starLawyer} key={index} />
                            );
                        })}
                    </div>
                </div>
            </main>
        </>
    );
};

export default StarLawyersPage;
